var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiftcardStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9986 48.9999C24.9804 42.6407 22.4463 36.5472 17.9497 32.0503C13.4531 27.5535 7.35951 25.0188 1 24.9999V24.9999C7.35951 24.981 13.4531 22.4463 17.9497 17.9494C22.4463 13.4525 24.9804 7.35901 24.9986 0.999878V0.999878C25.0167 7.3595 27.5512 13.4535 32.0484 17.9504C36.5457 22.4474 42.64 24.9818 49 24.9999C42.64 25.018 36.5457 27.5524 32.0484 32.0493C27.5512 36.5463 25.0167 42.6403 24.9986 48.9999V48.9999Z",
    stroke: "#E12FFF",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftcardStar);
export default __webpack_public_path__ + "static/media/giftcard-star.a615b3c3576ae0c147d5b5cb9a5caa0c.svg";
export { ForwardRef as ReactComponent };